export const setSights = (sights) => ({
	type: 'SET_SIGHTS',
	sights
});

export const updateSights = (sights) => ({
	type: 'UPDATE_SIGHTS',
	sights
});